module.exports = __webpack_public_path__ + "static/media/ico_partner.1b1d6623.svg";